import { render } from "./ProcessingPhotos.vue?vue&type=template&id=28edd938&scoped=true"
import script from "./ProcessingPhotos.vue?vue&type=script&lang=js"
export * from "./ProcessingPhotos.vue?vue&type=script&lang=js"

import "./ProcessingPhotos.vue?vue&type=style&index=0&id=28edd938&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_assitech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28edd938"]])

export default __exports__